<div class="main">
    <div class="section">
        <div class="header">
            {{'ATTACHDRIVER.attachDriver' | translate}}
            <i class="material-icons" (click)="closeDialog();">
                clear
            </i>
        </div>
        <div class="table"> 
            <!-- *ngIf="drivers.length;else noDrivers" -->
            <table mat-table  [dataSource]="drivers">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> 
                        <div class="input">
                                <i class="material-icons search">
                                        search
                                        </i>
                            <input type="text" [placeholder]="'ATTACHDRIVER.driverName' | translate" (keyup)="driverSearch();" [(ngModel)]="driverNameSeacrhKey">
                        </div>    
                    </th>
                    <td mat-cell *matCellDef="let row"> <img *ngIf="row.attachedVehicle" style="width: 20px;" src="assets/atach-driver.svg" alt=""> {{row.name}} </td>
                </ng-container>
                <ng-container matColumnDef="mobile">
                    <th mat-header-cell *matHeaderCellDef> 
                        <div class="input">
                                <i class="material-icons search">
                                        search
                                        </i>
                            <input type="text" [placeholder]="'ATTACHDRIVER.mobileNumber' | translate" (keyup)="driverSearch('mobile')" [(ngModel)]="driverPhoneSeacrhKey">
                        </div>    
                    </th>
                    <td mat-cell *matCellDef="let row"> {{row.mobile}} </td>
                </ng-container>
                <ng-container matColumnDef="picture">
                    <th mat-header-cell *matHeaderCellDef> {{'ATTACHDRIVER.picture' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> 
                        <img src="{{row.picture}}" height="30px" width="30px">
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> {{'ATTACHDRIVER.action' | translate}} </th>
                        <td mat-cell *matCellDef="let row"> 
                            <div class="submitButton" appDbclick (debounceClick)="check(row);">
                                <div class="button">
                                    {{'ATTACHDRIVER.attach' | translate}}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
            </table>
            <mat-paginator [ngStyle]="{'display': drivers.length?'block':'none'}" [length]="(drivers)? totalDrivers: 0" [pageSizeOptions]="[10,25,50,100]" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>

        </div>
            <div *ngIf="!drivers.length" class="noDrivers">
                {{'ATTACHDRIVER.noDriversFound' | translate}}
            </div>
    </div>
</div>